import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    hintContainer: {
        padding: '20px !important',
        marginTop: '20px !important',
    },
}));
